import ElearningPost from '@/components/elearning-post/ElearningPost.vue'
import vSelect from 'vue-select'
import { BPaginationNav, BPagination } from 'bootstrap-vue'
import fetchItems from '@/scripts/vue/api-axios'
import VueScrollTo from 'vue-scrollto'

const categoryId = typeof window.category_id === "undefined" ? 1011 : window.category_id
const perPageInitial = typeof window.perPageInitial === "undefined" ? 3 : window.perPageInitial

const elearningsListConfig = {
  components: {
    ElearningPost,
    vSelect,
    BPaginationNav,
    BPagination
  },
  mounted() {
    // start loader
    this.$Progress.start();

    // get videos
    fetchItems(`/yiifelearning?categoryId=${ categoryId }`)
      .then((videos) => {

        // sort video types
        this.videosTC = videos.filter(video => {
          return video.type === 'TC'
        });
        this.videosOthers = videos.filter(video => { 
            return video.type === 'Other'
        });

      })
      .then(() => {
          
        // get filters
        fetchItems(`/yiifcategory/elearning?categoryId=${ categoryId }`)
          .then((filters) => {
            this.scrollTo('body', 0);

            // sort filter types
            this.TcCategories = filters.filter(filter => {
                return filter.type === 'TC'
            });
            this.OthersCategories = filters.filter(filter => {
                return filter.type === 'Other'
            });
            

            // set the "Show All" option
            this.setShowAllOptions();

            // finish loader
            this.$Progress.finish();

            // category attribute from url
            const categoryTcParam = parseInt(window.utils.getQueryStringParameter('elearningTcCategory'));
            if ( categoryTcParam )
            {
              const currentTcCategory = this.TcCategories.filter(option => {
                return option.id == categoryTcParam
              });

              this.TcSelectedCategory = currentTcCategory[0].id;
            }

            const categoryOthersParam = parseInt(window.utils.getQueryStringParameter('elearningOthersCategory'));
            if ( categoryOthersParam )
            {
              const currentOthersCategory = this.OthersCategories.filter(option => {
                return option.id == categoryOthersParam
              });

              this.OthersSelectedCategory = currentOthersCategory[0].id;
            }

            // pagination attribute from url
            const pageTcParam = window.utils.getQueryStringParameter('elearningTcPage');
            if ( pageTcParam )
            {
              this.TccurrentPage = pageTcParam;
            }

            const pageOthersParam = window.utils.getQueryStringParameter('elearningOthersPage');
            if ( pageOthersParam )
            {
              this.OtherscurrentPage = pageOthersParam;
            }

            // per page attribute from url
            const perPageTcParam = window.utils.getQueryStringParameter('elearningTcPerPage');
            if ( perPageTcParam )
            {
              this.TcPerPage = parseInt(perPageTcParam);
            }

            const perPageOthersParam = window.utils.getQueryStringParameter('elearningOthersPerPage');
            if ( perPageOthersParam )
            {
              this.OthersPerPage = parseInt(perPageOthersParam);
            }

            // scrollTo attribute from url
            const scrollToParam = window.utils.getQueryStringParameter('scrollTo');
            if ( scrollToParam == 'TC' )
            {
              this.scrollToTC();
              window.utils.setQueryStringParameter('scrollTo', false);
            }
            else if ( scrollToParam == 'Others' )
            {
              this.scrollToOthers();
              window.utils.setQueryStringParameter('scrollTo', false);
            }


          })

      });

  },
  data: () => ({
    videosTC: [],
    videosOthers: [],

    TcCategories: [],
    OthersCategories: [],

    TcSelectedCategory: null,
    OthersSelectedCategory: null,

    TccurrentPage: 1,
    OtherscurrentPage: 1,

    TcPerPage: perPageInitial,
    OthersPerPage: perPageInitial,

    scrollerIsScrolling: false
  }),
  computed: {
    TcItemsForList(){
      return this.TcFilteredItems
      .slice(
        // slice per page
        (this.TccurrentPage - 1) * this.TcPerPage,
        this.TccurrentPage * this.TcPerPage,
      );
    },
    OthersItemsForList(){
      return this.OthersFilteredItems
      .slice(
        // slice per page
        (this.OtherscurrentPage - 1) * this.OthersPerPage,
        this.OtherscurrentPage * this.OthersPerPage,
      );
    },

    TcFilteredItems() {
        return this.videosTC.filter(video => {
            if ( !this.TcSelectedCategory ) return true;
            return video.type_id == this.TcSelectedCategory
        });
    },
    OthersFilteredItems() {
        return this.videosOthers.filter(video => {
            if ( !this.OthersSelectedCategory ) return true;
            return video.type_id == this.OthersSelectedCategory
        });
    },

    TcRows(){
      return this.TcFilteredItems.length
    },
    OthersRows(){
      return this.OthersFilteredItems.length
    }
  },
  methods: {
      setShowAllOptions(){
        // TcCategories Show all option
        if ( this.$refs.TcCategorySelect?.placeholder )
        {
            // get placeholder from ref select
            const placeholder = this.$refs.TcCategorySelect.placeholder;

            // fill clear option, append it as first element and select by default (id 0 is what makes it show all categories)
            const clearOption = {
                id: 0,
                name: placeholder,
                type: 'D'
            };

            this.TcCategories.unshift(clearOption);
            this.TcSelectedCategory = 0;
        }

        // OthersCategories Show all option
        if ( this.$refs.OthersCategorySelect?.placeholder )
        {
            // get placeholder from ref select
            const placeholder = this.$refs.OthersCategorySelect.placeholder;

            // fill clear option, append it as first element and select by default (id 0 is what makes it show all categories)
            const clearOption = {
                id: 0,
                name: placeholder,
                type: 'P'
            };

            this.OthersCategories.unshift(clearOption);
            this.OthersSelectedCategory = 0;
        }
      },
      scrollTo(target, duration, offset) {
        // if not scrolling already
        if ( !this.scrollerIsScrolling )
        {
          // scroll to target with desired duration
          VueScrollTo.scrollTo(target, {
            duration: duration,
            offset: offset,
            onStart: () => {
              // set scrolling variable
              this.scrollerIsScrolling = true;
            },
            onDone: () => {
              // unset scrolling variable
              this.scrollerIsScrolling = false;
            }
          });
        }
      },
      scrollToTC(remember = false){
        this.scrollTo('#videosTC', 500, -100);

        if ( remember )
        {
          window.utils.setQueryStringParameter('scrollTo', 'TC');
        }
      },
      scrollToOthers(remember = false){
        this.scrollTo('#videosOthers', 500, -100);

        if ( remember )
        {
          window.utils.setQueryStringParameter('scrollTo', 'Others');
        }
      }
  },
  watch: {
    TcPerPage: function(newValue, oldValue) {
      this.scrollToTC();

      if ( newValue != oldValue )
      {
        window.utils.setQueryStringParameter('elearningTcPerPage', this.TcPerPage);
      }
    },
    OthersPerPage: function(newValue, oldValue) {
      this.scrollToOthers();

      if ( newValue != oldValue )
      {
        window.utils.setQueryStringParameter('elearningOthersPerPage', this.OthersPerPage);
      }
    },

    TccurrentPage: function(newValue, oldValue) {
      this.scrollToTC();

      // change query string after changing pagination
      if ( newValue != oldValue )
      {
        window.utils.setQueryStringParameter('elearningTcPage', this.TccurrentPage);
      }
    },
    OtherscurrentPage: function(newValue, oldValue) {
      this.scrollToOthers();

      // change query string after changing pagination
      if ( newValue != oldValue )
      {
        window.utils.setQueryStringParameter('elearningOthersPage', this.OtherscurrentPage);
      }
    },

    TcSelectedCategory: function (newValue, oldValue) {
      if ( oldValue != newValue && oldValue != null ) {
        this.TccurrentPage = 1;
      }

      if ( newValue )
      {
        window.utils.setQueryStringParameter('elearningTcCategory', newValue);
      }
      else
      {
        window.utils.setQueryStringParameter('elearningTcCategory', 0);
      }
    },
    OthersSelectedCategory: function (newValue, oldValue) {
      if ( oldValue != newValue && oldValue != null ) {
        this.OtherscurrentPage = 1;
      }

      if ( newValue )
      {
        window.utils.setQueryStringParameter('elearningOthersCategory', newValue);
      }
      else
      {
        window.utils.setQueryStringParameter('elearningOthersCategory', 0);
      }
    }
  }
}

export default elearningsListConfig